export default __webpack_public_path__ + "static/media/pope_worldwide_it.d7a294c8.svg";